<template lang="pug">
  v-card.content-card(v-rc-loader="loading")
    v-layout.column.height
      v-layout.justify-end
        v-dialog(width="50%" v-model="newMapOpen" persistent)
          v-btn.mt-3.mb-3.mr-3(
            small fab
            color="primary"
            slot="activator"
          )
            v-icon(medium color="white") add
          v-card(v-rc-loader="createLoading")
            v-card-title.primary
              v-layout
                v-flex.xs10.offset-xs1
                  .headline.text-xs-center.white--text.font-weight-bold AJOUTER UNE CARTE
                v-flex.xs1.text-xs-right
                  v-icon(@click="newMapOpen = false" dark large) close
            v-card-text
              v-text-field(label="Nom de la carte" v-model="newMapName")
              v-textarea(label="Description" v-model="newMapDesc")
              v-layout.justify-end
                v-btn(@click="newMapOpen = false") Annuler
                v-btn(color="primary" @click="createConf") Créer
        v-dialog(width="50%" v-model="confirmeDelete" persistent)
          v-card(v-rc-loader="createLoading")
            v-card-title.create-conf
              v-layout
                v-flex.xs10.offset-xs1
                  .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold Suppression de la configuration
            v-card-text
              v-label Êtes-vous sûr de vouloir supprimer cette configuration ?
              v-layout.justify-center
                v-btn.grey--text(@click="confirmeDelete = false") Annuler
                v-btn(color="#e7523e" dark @click="deleteConfig()") Supprimer
      ol.scrollable.mt-4()
        li.item-container.header
          .cell.header-cell(v-for="items in headers") {{items.text}}
        li.item-container.row(v-for="props in configs")
          .cell
          .cell.first-column.icon() {{ props.id }}
          .cell(style="--column-width-min: 50px") {{ props.name }}
          .cell(style="--column-width-min: 50px") {{ props.description }}
          .cell(style="--column-width-min: 50px") {{ props.userName }}
          .cell {{ props.created | moment }}
          .cell {{ props.updated | moment }}
          .cell.image
            v-img.my-2(
              width="125px" height="125px"
              :src="`/api/v2/tmaps/configs/${props.id}/preview?t=${props.updated}`"
            )
          .cell.icon
            v-icon(@click="$router.push(`/maps/${props.id}`)") edit
          .cell.icon
            v-icon(v-if="!props.isDefault" @click="deleteConfig(props.id)") delete
</template>

<script>
import moment from 'moment';
import 'moment/locale/fr';

export default {
  data() {
    return {
      createLoading: false,
      newMapName: '',
      newMapDesc: '',
      newMapOpen: false,
      loading: true,
      confirmeDelete: false,
      headers: [
        {
          text: '',
          value: 'statue',
        },
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Créé par',
          value: 'userId',
        },
        {
          text: 'Crée le',
          value: 'created',
        },
        {
          text: 'Mise à jour le',
          value: 'updated',
        },
        {
          text: 'Preview',
          value: '',
        },
        {
          text: '',
          value: '',
        },
        {
          text: '',
          value: '',
        },
      ],
    };
  },
  filters: {
    moment(date) {
      const formattedDate = moment(date).format('ll').toString();
      const noDotDate = formattedDate.split('.').join('');
      const dateComps = noDotDate.split(' ');
      dateComps[1] = dateComps[1].replace(/^\w/, c => c.toUpperCase());
      return dateComps.join(' ');
    },
  },
  mounted() {
    this.$store.dispatch('config/get').then(() => { this.loading = false; });
  },
  computed: {
    configs() {
      return this.$store.state.config.configs;
    },
  },
  methods: {
    checkImage(imageSrc) {
      const http = new XMLHttpRequest();
      http.open('HEAD', imageSrc, false);
      http.send();
      return http.status !== 404;
    },
    async createConf() {
      this.createLoading = true;
      const newParams = {
        isDefault: false,
        name: this.newMapName,
        description: this.newMapDesc,
        position: {
          latitude: 46.99573076463421,
          longitude: 2.578399338685542,
          zoom: 6,
        },
        theme: {
          colors: {
            primary: '#cdcdcd',
            secondary: '#cdcdcd',
          },
          tint_intensity: 6,
        },
        icons: {
          disabled: [],
        },
        elements: {
          disabled: [],
        },
        map: {
          dragging: true,
          keyboardZoomOffset: true,
          scrollWheelZoom: 2,
        },
        zoom: {
          state: true,
        },
        fullscreen: {
          state: true,
        },
        locate: {
          state: true,
        },
        geosearch: {
          state: true,
        },
        carto: {
          state: true,
        },
        popin: {
          disabled: [],
        },
        link: {
          disabled: [],
        },
      };
      await this.$store.dispatch('config/create', newParams);
      this.newMapOpen = false;
      this.createLoading = false;
      await this.$store.dispatch('config/get');
      /* this.$store.dispatch('config/create', newParams).then((data) => {
        console.log("data");
        console.log(data);
        this.createLoading = false;
        this.$router.push(`/maps/${data.id}`);
      }); */
    },
    async deleteConfig(id) {
      if (id) {
        this.deleteId = id;
        this.confirmeDelete = true;
      } else {
        this.confirmeDelete = false;
        this.loading = true;
        await this.$store.dispatch('config/deleteById', this.deleteId);
        await this.$store.dispatch('config/get');
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  #map-list {
    width: 100%;
    .v-table__overflow {
      height: calc(100vh - 333px);
      overflow-y: auto;
    }
    tbody {
      tr:nth-of-type(2n) {
        background-color: #eee;
        &:hover {
          background-color: #ddd;
        }
      }
    }
  }
</style>
